import Helper from './Helper';

export default class JSONP {
	static onSet(callback) {
		JSONP.on_set = callback;
	}

	static hasOnSet() {
		return Helper.type(JSONP.on_set, 'function');
	}

	static set(content) {
		if (JSONP.hasOnSet())
			JSONP.on_set(content);
	}
}